import { Box, Card, Typography, Button } from '@mui/material';
import {
  InsertDriveFile as FileIcon,
  Download as DownloadIcon,
  Share as ShareIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { colors } from '../../../utils/colors';

const DocumentCard = ({ document, customerId, projectId, folderId }) => {
  const handleDownload = () => {
    if (document.file_url) {
      window.open(document.file_url, '_blank');
    }
  };

  const handleShare = () => {
  };

  const handleDelete = () => {
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return 'N/A';
    return `${(bytes / 1024).toFixed(2)} KB`;
  };

  return (
    <Card
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: { xs: 2, sm: 2.5, md: 3 },
        border: `1px solid ${colors.alpha.black08}`,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: colors.primary.light,
          boxShadow: `0 2px 8px ${colors.alpha.black08}`
        }
      }}  
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
        <FileIcon
          sx={{
            color: colors.primary.main,
            fontSize: { xs: 28, sm: 32 }
          }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: { xs: '0.813rem', sm: '0.875rem', md: '0.95rem' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              mb: 0.5
            }}
          >
            {document.name}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: colors.text.secondary,
              fontSize: { xs: '0.688rem', sm: '0.75rem' }
            }}
          >
            {formatFileSize(document.file_size)}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
          onClick={handleDownload}
          sx={{
            flex: 1,
            textTransform: 'none',
            fontSize: { xs: '0.688rem', sm: '0.75rem' },
            py: { xs: 0.5, sm: 0.625 },
            px: { xs: 0.75, sm: 1 },
            borderColor: colors.primary.main,
            color: colors.primary.main,
            minWidth: 0,
            '&:hover': {
              borderColor: colors.primary.dark,
              bgcolor: colors.primary.light + '20'
            }
          }}
        >
          <Box
            component="span"
            sx={{
              display: { xs: 'none', sm: 'inline' }
            }}
          >
            Download
          </Box>
        </Button>
        {/* <Button
          size="small"
          variant="outlined"
          startIcon={<ShareIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
          onClick={handleShare}
          sx={{
            flex: 1,
            textTransform: 'none',
            fontSize: { xs: '0.688rem', sm: '0.75rem' },
            py: { xs: 0.5, sm: 0.625 },
            px: { xs: 0.75, sm: 1 },
            borderColor: colors.info.main,
            color: colors.info.main,
            minWidth: 0,
            '&:hover': {
              borderColor: colors.info.main,
              bgcolor: colors.info.light + '20'
            }
          }}
        >
          <Box
            component="span"
            sx={{
              display: { xs: 'none', sm: 'inline' }
            }}
          >
            Share
          </Box>
        </Button> */}
        {/* <Button
          size="small"
          variant="outlined"
          startIcon={<DeleteIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
          onClick={handleDelete}
          sx={{
            flex: 1,
            textTransform: 'none',
            fontSize: { xs: '0.688rem', sm: '0.75rem' },
            py: { xs: 0.5, sm: 0.625 },
            px: { xs: 0.75, sm: 1 },
            borderColor: colors.error.main,
            color: colors.error.main,
            minWidth: 0,
            '&:hover': {
              borderColor: colors.error.dark,
              bgcolor: colors.error.light + '20'
            }
          }}
        >
          <Box
            component="span"
            sx={{
              display: { xs: 'none', sm: 'inline' }
            }}
          >
            Delete
          </Box>
        </Button> */}
      </Box>
    </Card>
  );
};

export default DocumentCard;